import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';

@Component({
  selector: 'app-script-inline',
  templateUrl: './script-inline.component.html',
  styleUrls: ['./script-inline.component.scss']
})
export class ScriptInlineComponent implements AfterViewInit {

  constructor(private elementRef: ElementRef) {
  }

  @Input()
  src: string;

  @Input()
  async: boolean;

  @Input()
  text: string;

  @Input()
  type: string;

  @Input()
  noScript: boolean;

  ngAfterViewInit() {
    let s;
    if (this.noScript) {
      s = document.createElement('noscript');
    } else {
      s = document.createElement('script');
      s.type = this.type ? this.type : 'text/javascript';
    }
    if (this.async) {
      s.async = this.async;
    }
    if (this.src) {
      s.src = this.src;
    }
    if (this.text) {
      s.innerHTML = this.text;
    }
    this.elementRef.nativeElement.appendChild(s);
  }

}
